import Vue from 'vue';
import axios from 'axios';
import VueFormWizard from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { StripePlugin } from '@vue-stripe/vue-stripe';
import Notifications from 'vue-notification';
import App from './App.vue';
import router from './router';
import store from './store';
import setupHttp from './http/setup';
import './validation';

// App css
require('./assets/scss/app.scss');

// Tailwind
require('./assets/scss/vendor/tailwind.css');

// Vue Form Wizard
Vue.use(VueFormWizard);

// Notifications
Vue.use(Notifications);

// Http
setupHttp({ store, router });

// Stripe
store
  .dispatch('dashboard/getDashboardConfig', { domain: window.location.hostname })
  .then(() => {
    if (store.state.dashboard.dashboardConfig.stripe) {
      Vue.use(StripePlugin, {
        ...store.state.dashboard.dashboardConfig.stripe,
        apiVersion: '2020-08-27',
        locale: 'pt-BR',
      });
    }
  });

// Vue config
Vue.prototype.$http = axios;
Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^ion-/];

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

if (window.Cypress) {
  window.app = app;
}
